<template>
  <div class="install-page" id="en">
    <div class="install-page-header">
      <div>
        <div v-html="$t('logo')"></div>
      </div>
      <div style="margin-top: 20px;">
        <div v-html="$t('title')"></div>
      </div>
    </div>
    <div class="block">

    </div>
    <div class="app-store-button-container">
      <div class="app-store-button" @click="installAppStore">
        <div v-html="$t('appStoreButton')"></div>
      </div>
      <div class="google-play-button" @click="installGooglePlay()">
        <div v-html="$t('googlePlayButton')"></div>
      </div>
    </div>
  </div>
  <!-- 蒙板 -->
  <div v-if="showMask" class="mask-arrow">
      <svg width="144" height="141" viewBox="0 0 144 141" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M129.189 0.0490494C128.744 0.119441 126.422 0.377545 124.03 0.635648C114.719 1.6446 109.23 2.4893 108.058 3.09936C107.119 3.56864 106.674 4.34295 106.674 5.44576C106.674 6.71281 107.424 7.51058 109.043 7.97986C110.403 8.37875 110.825 8.42567 118.87 9.52847C121.778 9.92736 124.288 10.3028 124.475 10.3732C124.663 10.4436 122.951 11.1006 120.676 11.8749C110.028 15.4414 100.412 20.7677 91.7339 27.9242C88.38 30.7164 81.6957 37.4271 79.2096 40.5009C73.8387 47.2116 69.6874 54.8139 66.5681 63.7302C65.9348 65.4665 65.3484 66.8978 65.2546 66.8978C65.1374 66.8978 63.7771 66.7336 62.2291 66.5693C52.9649 65.5134 43.1847 68.1649 34.1316 74.2186C24.7735 80.46 18.5349 87.7338 10.5371 101.742C2.53943 115.726 -1.0959 127.482 0.287874 135.014C0.89767 138.463 2.0469 140.035 3.97011 140.082C5.28352 140.105 5.37733 139.659 4.20465 139.049C3.05541 138.463 2.6567 137.9 2.32835 136.281C0.616228 128.021 6.24512 113.028 17.4325 96.1104C23.2725 87.241 28.362 81.9147 35.5622 77.1046C43.8649 71.5437 52.7069 69.033 61.1737 69.8308C64.9967 70.1828 64.6917 69.9247 64.1992 72.4822C62.2525 82.5013 63.8005 92.6378 67.9753 97.354C73.1116 103.079 81.9771 102 85.0027 95.2657C86.3395 92.2858 86.3864 87.7103 85.1434 83.9796C83.1498 78.0901 80.007 73.8197 75.4335 70.8163C73.8152 69.7604 70.4848 68.1883 69.875 68.1883C69.359 68.1883 69.4294 67.6487 70.2268 65.3257C72.3377 59.2486 75.457 52.7021 78.4122 48.244C83.2436 40.9232 91.4524 32.5701 99.1687 27.103C105.806 22.4102 113.241 18.5386 120.512 16.0045C123.772 14.8548 129.87 13.1889 130.081 13.3766C130.128 13.447 129.541 14.362 128.791 15.4414C124.78 21.0258 122.716 26.0706 122.388 30.998C122.224 33.7198 122.341 34.588 122.88 34.2595C122.998 34.1891 123.678 32.969 124.405 31.5611C126.281 27.8069 131.722 20.6738 139.579 11.6402C141.127 9.85697 142.652 7.86254 143.027 7.08823C144.552 4.03792 143.52 1.48035 140.377 0.471397C139.439 0.166366 138.102 0.0490408 134.584 0.0255769C132.074 -0.021351 129.635 0.00212153 129.189 0.0490494ZM137.117 4.92955C137.187 5.0234 136.718 5.63346 136.061 6.29045L134.865 7.48712L131.042 6.73627C128.931 6.33739 126.727 5.9385 126.14 5.8681C124.827 5.68039 124.123 5.32843 124.968 5.28151C125.296 5.28151 126.868 5.11725 128.486 4.953C131.3 4.64797 136.812 4.62451 137.117 4.92955ZM71.5168 72.5292C76.2075 74.899 79.4441 78.8175 81.3204 84.355C83.6189 91.1361 81.2266 96.8378 76.0433 96.8847C73.3227 96.9082 70.9773 95.2188 69.5936 92.2389C68.2802 89.4232 67.6938 86.5606 67.5765 82.1259C67.4593 78.3248 67.6 76.4242 68.2333 72.7403L68.4912 71.2856L69.359 71.5906C69.8515 71.7548 70.8132 72.1772 71.5168 72.5292Z" fill="#FFFFFF"/>
      </svg>
  </div>
  <div v-if="showMask" class="mask container">
    <div class="mask-instruction">
      *点击右上角，选择「浏览器打开」
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import {onMounted, ref} from "vue";

const { locale } = useI18n();
const showMask = ref(false);
// 识别品牌
const getDeviceBrand = () => {
  const ua = navigator.userAgent.toUpperCase();
  const brands = {
    HUAWEI: 'HUAWEI',
    XIAOMI: 'MI|REDMI',
    OPPO: 'OPPO',
    VIVO: 'VIVO',
    SAMSUNG: 'SAMSUNG'
  };

  for (const brand in brands) {
    if (new RegExp(brands[brand]).test(ua)) {
      return brand;
    }
  }

  return null;
};
onMounted(() => {
  const isWechat = /wechat/i.test(navigator.userAgent) || /MicroMessenger/i.test(navigator.userAgent);
  if(isWechat){
    showMask.value = true;
  }
});
const installGooglePlay = () => {
  const isWechat = /wechat/i.test(navigator.userAgent) || /MicroMessenger/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const deviceBrand = getDeviceBrand();
  let downloadLink = 'https://d3j9vygjocoacx.cloudfront.net/app/NadaPrint.apk'; // 默认国际APK
  if (isWechat){
    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zhuhaijiuyin.dayin';
    return;
  }
  if (!isAndroid) {
    // 非安卓设备，跳转通用下载页或提示
    window.location.href = downloadLink;
    return;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const brandValue = urlParams.get('brand')?.toUpperCase();
  if (locale.value === 'zh'){
    switch (deviceBrand) {
      case 'HUAWEI':
        downloadLink = 'market://details?id=com.zhuhaijiuyin.dayin';
        break;
      case 'XIAOMI':
        downloadLink = 'mimarket://details?id=com.zhuhaijiuyin.dayin';
        break;
      case 'OPPO':
        downloadLink = 'market://details?id=com.zhuhaijiuyin.dayin';
        break;
      case 'VIVO':
        downloadLink = 'vivoMarket://details?id=com.zhuhaijiuyin.dayin';
        break;
      default:
        downloadLink = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zhuhaijiuyin.dayin'; // 应用宝兜底
        break;
    }
    if (downloadLink === 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zhuhaijiuyin.dayin'){
      switch (brandValue) {
        case 'HUAWEI':
          downloadLink = 'market://details?id=com.zhuhaijiuyin.dayin';
          break;
        case 'XIAOMI':
          downloadLink = 'mimarket://details?id=com.zhuhaijiuyin.dayin';
          break;
        case 'OPPO':
          downloadLink = 'market://details?id=com.zhuhaijiuyin.dayin';
          break;
        case 'VIVO':
          downloadLink = 'vivoMarket://details?id=com.zhuhaijiuyin.dayin';
          break;
        default:
          downloadLink = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zhuhaijiuyin.dayin'; // 应用宝兜底
          break;
      }
    }
  }else{
     downloadLink = 'https://play.google.com/store/apps/details?id=com.zhuhaijiuyin.print'
  }
  window.location.href = downloadLink;
}
const installAppStore = () => {
   window.location.href = 'https://apps.apple.com/app/nada-print/id6739829512';
}

</script>

<style scoped>
.install-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh
}

img {
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.app-store-button,
.google-play-button {
  margin: 10px 0;
  width: 300px; /* 调整按钮宽度 */
  height: 50px; /* 调整按钮高度 */
  border-radius: 25px; /* 设置圆角 */
  background-color: #333; /* 设置背景颜色 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* 添加阴影 */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; /* 隐藏超出边界的元素 */
  cursor: pointer;
}

.block {
  height: 100px;
  margin-top: 150px;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
}
.mask-arrow {
  position: absolute;
  top: -10px; /* 调整顶部距离 */
  right: 50px; /* 靠近右侧 */
  z-index: 1001;
}
.mask-arrow svg {
  fill: #FFFFFF; /* 确保箭头填充颜色为白色 */
  stroke: #FFFFFF; /* 如果有描边，也设置为白色 */
  filter: brightness(1.2); /* 增加亮度 */
  transform: rotate(15deg); /* 旋转45度 */
}
.mask-instruction {
  color: #fff;
  font-size: 16px;
  margin-top: 10px;
  position: relative;
}
.mask-content p {
  margin-bottom: 20px;
}

.container > * {
  border: solid 1px #bebebe;
  background-color: #1f1f1f;
  position: absolute;
  border-radius: 10px;
  padding: 10px;
  color: #fff;
  box-shadow: 0 8px 20px -10px #bbbbbb;
  text-shadow: 0 0 5px #fff;
  letter-spacing: 1px;
  background-image: radial-gradient(circle 160px at 50% 120%, #353535, #1f1f1f);
  top: 100px;
}

</style>
